import React, { useState } from 'react';
import Button from './Button';

const Confirm = ({ message, onConfirm, children,isLoading, buttonClassName, value }) => {
  
  const [isShow, setIsShow] = useState(false)

  const handleOnShow = e => {
    e.preventDefault()

    setIsShow(true)
  }

  const handleNo = e => {
    e.preventDefault()
    setIsShow(false)
  }

  const handleYes = e => {
    e.preventDefault()
    setIsShow(false)
    onConfirm(value)
  }
  
  return (
    <div className="relative">
      <div  style={{bottom: 45}} className={`${isShow ? 'flex' : 'hidden' } right-0 dialog border absolute bg-gray-300 -mt-32 flex-col space-y-2 p-2 rounded shadow`}>
        <span className="bg-white rounded text-sm p-2">{message}</span>
        <div className="flex space-x-2 justify-end">
          <Button className="!bg-warning text-sm !text-black" onClick={handleYes}>Yes</Button>
          <Button className="!bg-black text-sm" onClick={handleNo}>No</Button>
        </div>
      </div>
      <Button isLoading={isLoading} className={buttonClassName} type="button" onClick={handleOnShow}>
        {children}
      </Button>
    </div>
  )
}

export default Confirm